import type { CategoryContent } from '../row.js';

export const DANISH_HISTORY: CategoryContent = {
  bscba: [
    [
      'Wat is de naam van de persoonlijke unie die Denemarken, Noorwegen en Zweden van 1397 tot 1523 verbond?',
      [
        'De Unie van Kalmar',
        'De Hanzische Unie',
        'De Noordse Confederatie',
        'Het Scandinavische Verdrag',
      ],
      0,
      'De Unie van Kalmar verenigde Denemarken, Noorwegen en Zweden onder één vorst. Zweden vertrok in 1523.',
    ],
    [
      'Welke Deense koning veroverde Engeland en Noorwegen en stichtte een Noord-Zeerijk in het begin van de 11de eeuw?',
      [
        'Knoet de Grote',
        'Harald Bluetooth',
        'Svend Tweebaardige',
        'Christiaan IV',
      ],
      0,
      'Knoet II (regeerde 1019–1035) veroverde Engeland en Noorwegen en creëerde een kortstondig Noord-Zeerijk.',
    ],
    [
      'In welk jaar nam Denemarken het lutheranisme aan en brak het officieel met de Rooms-Katholieke Kerk?',
      [
        '1536',
        '1517',
        '1534',
        '1545',
      ],
      0,
      'Denemarken aanvaardde het lutheranisme in 1536 onder Koning Christiaan III en verbrak de banden met Rome.',
    ],
    [
      'Welk conflict in 1864 leidde tot het verlies van Sleeswijk en Holstein door Denemarken aan Pruisen?',
      [
        'Slesische Oorlog',
        'De Grote Noordse Oorlog',
        'De Dertigjarige Oorlog',
        'De Holstein-Opstand',
      ],
      0,
      'De Tweede Slesische Oorlog (1864) eindigde in Deense nederlaag en afstand van Sleeswijk en Holstein aan Pruisen.',
    ],
    [
      'Waarom verloor Denemarken Noorwegen aan Zweden onder het Verdrag van Kiel in 1814?',
      [
        'Denemarken steunde Napoleon',
        'Noorwegens bevolking eiste onmiddellijke onafhankelijkheid',
        'Een zeeslag gaf Zweden controle',
        'De Storting verwierp het verdrag volledig',
      ],
      0,
      'Denemarken steunde Napoleon, dus het Verdrag van Kiel (1814) overdroeg Noorwegen aan Zweden als straf.',
    ],
    [
      'Welke Deense koning richtte in 1660 het absolute koningschap in door de Koninklijke Wet in te stellen?',
      [
        'Frederik III',
        'Christiaan IV',
        'Christiaan VI',
        'Frederik V',
      ],
      0,
      'Frederik III voerde in 1660 de Kongelov (Koninklijke Wet) in en verving de elektieve monarchie door absolutisme.',
    ],
    [
      'Welke belangrijke hervorming van de late 18de eeuw verbeterde de toestand van boeren door versnipperde landerijen samen te voegen?',
      [
        'Landherverkaveling',
        'De Boerenopstand',
        'De Insluitingsbeweging',
        'De Landbouwrevolutie',
      ],
      0,
      'Hervormingen in de jaren 1770–1780 voegden boerenlanderijen samen en verminderden de lijfeigenschap, wat het platteland moderniseerde.',
    ],
    [
      'In welk jaar werd Denemarkens eerste constitutionele monarchie ingesteld?',
      [
        '1849',
        '1848',
        '1864',
        '1901',
      ],
      0,
      'De Grondwet van 1849 vestigde constitutionele monarchie en een tweekamerig parlement.',
    ],
    [
      'Welke Deense wetenschapper won de Nobelprijs Natuurkunde voor bijdragen aan de atoomtheorie?',
      [
        'Niels Bohr',
        'Hendrik Lorentz',
        'Max Planck',
        'Albert Einstein',
      ],
      0,
      'Niels Bohr won de Nobelprijs voor zijn atoommodel en kwantumbijdragen.',
    ],
    [
      'Wat was Denemarkens primaire status tijdens de Tweede Wereldoorlog (1940–1945)?',
      [
        'Bezet door nazi-Duitsland',
        'Een actieve nazi-bondgenoot gedurende de hele oorlog',
        'Neutraal en nooit bezet',
        'Een lid van de geallieerde strijdkrachten',
      ],
      0,
      'Duitsland invaseerde Denemarken in april 1940. Denemarken bleef bezet tot mei 1945, al bleef er Deens burgerbeheer onder nazi-toezicht.',
    ],
    [
      'Wat is de naam van Denemarkens voornaamste wetgevingslichaam, ingesteld in 1849?',
      [
        'De Folketing',
        'De Rigsråd',
        'De Rigsdagog',
        'De Landsting',
      ],
      0,
      'De Folketing (volksvergadering) is sinds 1849 Denemarkens belangrijkste wetgevingsorgaan.',
    ],
    [
      'Welke Deense filosoof is vooral bekend om zijn existentialistische geschriften en zijn kritiek op het institutionele christendom?',
      [
        'Søren Kierkegaard',
        'Georg Wilhelm Hegel',
        'Bertrand Russell',
        'Ludwig Wittgenstein',
      ],
      0,
      'Søren Kierkegaard was een pionier van de existentialistische filosofie en bekritiseerde het institutionele christendom.',
    ],
    [
      'Wat was de primaire economische basis van middeleeuws Denemarken?',
      [
        'Handel, visserij en landbouw',
        'Mijnbouw en edelmetalen',
        'Vervaardiging en textiel',
        'Koloniale ondernemingen in Amerika',
      ],
      0,
      'Middeleeuws Denemarken steunde op Baltische handel, visserij en landbouw. De Øresundtol bracht rijkdom.',
    ],
    [
      'In welk jaar ging Denemarken over van een tweekamerig naar een eenkamerig parlement?',
      [
        '1953',
        '1901',
        '1849',
        '1939',
      ],
      0,
      'De Grondwet van 1953 creëerde een eenkamerig Folketing en schafte de Senatorkamer af.',
    ],
    [
      'Welke Noordse dynastie regeerde Denemarken van 1448 tot het moderne tijdperk?',
      [
        'Het Huis Oldenburg',
        'Het Huis Glücksburg',
        'Het Huis Estridsson',
        'Het Huis Gottorp',
      ],
      0,
      'Het Oldenburg-huis regeerde Denemarken vanaf 1448 en bleef aan het bewind tot het moderne tijdperk.',
    ],
  ],
  msc: [
    [
      'Wat was het voornaamste territoriale gevolg van het Verdrag van Roskilde (1658) voor Denemarken?',
      [
        'Verloor Scania, Blekinge en Halland aan Zweden',
        'Denemarken herkreeg Noorwegen van Zweeds bestuur',
        'Denemarken verkreeg Sleeswijk-Holstein als vergoeding',
        'Denemarken vestigde Noord-Zeemachtdominantie',
      ],
      0,
      'Het Verdrag van Roskilde (1658) droeg Scania, Blekinge en Halland aan Zweden over en veranderde de Baltische geopolitiek.',
    ],
    [
      'Welke juridische doctrine, geformaliseerd in 1660, onderwierp de Deense adel aan de kroon?',
      [
        'De Kongelov',
        'De Danske Lov (Deense Wet)',
        'De Grundloven (Grondwet)',
        'De Privilegium Sigismundi',
      ],
      0,
      'De Kongelov (1660) vestigde absolutistische monarchie door macht te concentreren en het adelveto af te schaffen.',
    ],
    [
      'Hoe fungeerde Denemarkens controle over de Øresundstraat als mercantilistische inkomstenbron?',
      [
        'Toltarief op scheepvaart',
        'Directe koloniale handel met Afrika',
        'Zware binnenlandse vervaardigingsuitvoer',
        'Handhaving van Navigatiewetten',
      ],
      0,
      'Denemarken exploiteerde de Øresundstraat winstgevend door tollen te heffen. Deze inkomsten maakten Denemarken een grootmacht.',
    ],
    [
      'Welke hervorming in de jaren 1770–1780 schafte de lijfeigenschap van de boeren af en stimuleerde eigendomsrecht?',
      [
        'Afschaffing van het stavnsbånd',
        'De Reformatio Sigismundi',
        'De Wet op Huwelijk en Erfenis',
        'De Gilde-Ordonnantie',
      ],
      0,
      'Hervormingen in de jaren 1770–1780 schaften de lijfeigenschap af en voegden boerenlanderijen samen. Dit transformeerde het platteland.',
    ],
    [
      'Hoe hervormde de Grundtvig-beweging de Deense onderwijscultuur en het populaire nationalisme?',
      [
        'Volksscholen en volkstaal',
        'Het importeerde Duitse universiteitsmodellen',
        'Het beperkte onderwijs tot adel en geestelijkheid',
        'Het aanvaardde Pruisische militaire academies',
      ],
      0,
      'Grundtvig bevorderde volksscholen met nadruk op de Deense taal en geschiedenis, wat de basis legde voor de Deense identiteit.',
    ],
    [
      'Welke politieke verschuiving maakte de parlementaire hervorming van 1901 mogelijk in de Deense kiezerspolitiek?',
      [
        'Stemrecht voor boeren',
        'Volledige afschaffing van lokaal bestuur',
        'Onmiddellijke aanvaarding van evenredige vertegenwoordiging',
        'Overdracht van parlement naar de monarchie',
      ],
      0,
      'De hervorming van 1901 breidde stemrecht uit naar landelijke kleine landeigenaren, wat Venstre-dominantie mogelijk maakte.',
    ],
    [
      'Welke Noordse diplomatieke crisis in het begin van de 20ste eeuw dreef Denemarken naar strategische neutraliteit?',
      [
        'De splitsing van 1905',
        'De Russisch-Japanse Oorlog',
        'De Boerenoorlog',
        'De Ierse onafhankelijkheidsbeweging',
      ],
      0,
      'De Zweeds-Noorweegse splitsing van 1905 en Pruisisch militarisme duwden Denemarken naar neutraliteit.',
    ],
    [
      'Wat kenmerkte Denemarkens "Samenwerkingspolitiek" (Samarbejdspolitikken) tijdens nazi-bezetting?',
      [
        'Beperkt burgerbestuur behouden',
        'Volledige weerstand en regering in ballingschap',
        'Onmiddellijke oorlogsverklaring aan Duitsland',
        'Nooit formeel bezet',
      ],
      0,
      'Denemarkens samenwerkingsbeleid stelde burgerbestuur onder bezetting mogelijk. Historiografie debatteert over de vraag of dit collaboratie was.',
    ],
    [
      'Hoe herdefinieerde het Kanslergade-Akkoord (1933) tussen Venstre en Sociaaldemocraten het bestuur tijdens de Grote Depressie?',
      [
        'Coalitie voor publieke werken',
        'Het schaft democratische instellingen af',
        'Het privatiseerde alle staatsbedrijven',
        'Het introduceerde streng bezuinigingsbeleid',
      ],
      0,
      'Het Kanslergade-Akkoord van 1933 verenigde agrarische en arbeiderspartijen en financierde publieke werken. Dit voorafschaduwde het Noordse model.',
    ],
    [
      'Hoe vormden onderhandelingen na de oorlog Denemarkens territoriale en geopolitieke schikking na 1945?',
      [
        'Noord-Sleeswijk terug',
        'Ze losten de monarchie op',
        'Ze aanvaardden Sovjet-bezetting',
        'Ze wezen alle herstelbetalingen af',
      ],
      0,
      'Onderhandelingen na 1945 gaven Noord-Sleeswijk terug aan Denemarken. Denemarken trad in 1949 toe tot de NAVO.',
    ],
    [
      'Welk historiografisch debat omgeeft Deense economische "collaboratie" tegenover "pragmatische neutraliteit" tijdens WWII-bezetting?',
      [
        'Voedseluitvoer: misdaad of noodzaak',
        'Volledige consensus bestaat over Deense onschuld',
        'Geen historische gegevens bestaan van enige handel',
        'Denemarken verklaarde zich openlijk onderdeel van nazi-Duitsland',
      ],
      0,
      'Historici debatteren of Deense voedseluitvoer naar nazi-Duitsland collaboratie of geforceerde pragmatisme uitmaakte.',
    ],
    [
      'Hoe consolideerde Margaretha I (regeerde 1353–1412) Scandinavische politieke eenheid?',
      [
        'Via erfrecht en diplomatie',
        'Ze schafte de monarchie af',
        'Ze overdroeg Denemarken aan Duitsland',
        'Ze bekeerde Denemarken tot het katholicisme',
      ],
      0,
      'Margaretha I verenigde Scandinavië via erfrecht en diplomatie. De Unie van Kalmar van 1397 formaliseerde haar prestatie.',
    ],
    [
      'Hoe verschilde de Grondwet van 1849 van de constitutionele herziening van 1863?',
      [
        'Grondwet van 1849 was liberaler',
        'Beide waren identiek',
        'De versie van 1863 schafte de monarchie af',
        'De versie van 1849 had geen parlement',
      ],
      0,
      'De Grondwet van 1849 was democratischer. De herziening van 1863 beperkte het stemrecht en versterkte de conservatieven.',
    ],
    [
      'Welke geopolitieke transitie vertegenwoordigde de Britse blokkade (1807–1814) en het verlies van Noorwegen?',
      [
        'Einde van Denemarken als grote macht',
        'Denemarkens consolidatie van Mediterrane invloed',
        'Een toename van Franse steun',
        'Denemarkens verwerving van Britse koloniën',
      ],
      0,
      'Steun aan Napoleon leidde tot blokkade en Noors verlies. Denemarken daalde van een regionale grootmacht naar een kleinere Noordse staat.',
    ],
    [
      'Welke persoon uit de 18de eeuw wiens hervormingsinitiatieven (1770–1772) vroeg-feodale privileges betwistten vóór een conservatieve staatsgreep?',
      [
        'Struensee',
        'Frederik III',
        'Christiaan VI',
        'Ove Høgh-Guldberg',
      ],
      0,
      'Struensee\'s agrarische en juridische hervormingen bedreigden de adel. Een staatsgreep zette hem af en keerde de hervormingen terug.',
    ],
  ],
  phd: [
    [
      'Hoe veranderden de afschaffing van stavnsbåndet (1788) en landherverkavelingshervormingen (jaren 1770–1780) fundamenteel de Deense agrarische sociale structuur?',
      [
        'Eigendomsrecht en arbeidscheiding',
        'Ze handhaafden eeuwig feodale verplichtingen',
        'Ze schepen onmiddellijk een industrieel arbeidersklasse',
        'Ze exporteerden de gehele boerenstand naar Rusland',
      ],
      0,
      'Afschaffing van stavnsbåndet en landherverkaveling creëerden vrije boeren en landlozen. Dit maakte agrarisch kapitalisme mogelijk.',
    ],
    [
      'Hoe veroorzaakten afnemende Øresundtolbaten (jaren 1600–1700) de fiscale crisis die absolutisme rechtvaardigde?',
      [
        'Tolbaten daalden, absolutisme volgde',
        'Tolbaten stegen oneindig',
        'Denemarken vertrouwde nooit op tolerantie',
        'Tolafname versterkte democratie',
      ],
      0,
      'Afnemende tollen creëerden fiscale druk. Frederik III\'s absolutisme (1660) centraliseerde de rijkdomsextractie.',
    ],
    [
      'Hoe belichaamde de Struensee-periode (1770–1772) de conflicten rond Verlichtingshervormingen, en waarom riepen agrarische belangen tegenstand op?',
      [
        'Bedreigde adelprivileges',
        'Hij werd universeel geprezen',
        'De hervormingen hadden geen impact',
        'Struensee versterkte adel',
      ],
      0,
      'Struensee\'s agrarische hervormingen betwistten het feodalisme. De adel orkestreerde zijn executie en de staatsgreep van 1772.',
    ],
    [
      'Hoe hervormden de Napoleontische Oorlogen Denemarkens strategische belangen en langetermijnkoers?',
      [
        'Einde grootmacht, liberale wending',
        'Denemarken profiteerde massaal van Napoleontische allianties',
        'Denemarken schakelde onmiddellijk naar de Duitse zijde',
        'De oorlogen hadden geen impact op strategie',
      ],
      0,
      'Napoleontische steun leidde tot blokkade en Noors verlies. Denemarken verschoof naar constitutionalisme en verwestersing.',
    ],
    [
      'Welke historiografische betekenis heeft Grundtvigs beweging voor weerstand tegen Duitse culturele hegemonie?',
      [
        'Weerstond Pruisische druk',
        'Grundtvig bevorderde Duitse cultuur',
        'De beweging had geen culturele impact',
        'Grundtvig was Pruisische agent',
      ],
      0,
      'Grundtvig benadrukte de Deense taal en folklore als bolwerk tegen Duitse cultureel-politieke druk.',
    ],
    [
      'Hoe katalyseerde de Sleeswijk-Holstein-nederlaag van 1864 constitutionele herzieningen en generatiekloven in de politiek?',
      [
        'Radicaliseerde stemrechtdebatten',
        'De oorlog was betekenisloos',
        'Denemarken won de oorlog van 1864',
        'Er waren geen constitutionele herzieningen',
      ],
      0,
      'De nederlaag van 1864 versplinterde de Deense machtsverhoudingen. Constitutionele herzieningen reflecteerden nieuwe identiteitsangsten.',
    ],
    [
      'Welke rol speelde de coöperatievebeweging (andelsbevaegelsen) in de Deense agrarische modernisering?',
      [
        'Bundelde boerenkapitaal',
        'Coöperaties waren geheel afwezig',
        'Ze versterkte feodalisme',
        'Ze veroorzaakten landbouwinstorting',
      ],
      0,
      'De coöperatievebeweging stelde kleine boeren in staat collectief zuivel en granen uit te voeren. Coöperaties vormden de basis van het agrarische succes.',
    ],
    [
      'Hoe vormden de schikking van Noord-Sleeswijk (1945–1950) en de uitsluiting van Zuid-Sleeswijk de Deense identiteit na de oorlog?',
      [
        'Noord-Sleeswijk keerde terug, Zuid-Sleeswijk bleef Duits',
        'Denemarken herkreeg alle Sleeswijk-territoria',
        'Sleeswijk werd aan Zweden afgestaan',
        'Er was geen na-oorlogse schikking',
      ],
      0,
      'De schikking van 1945 keerde Noord-Sleeswijk terug. Zuid-Sleeswijk bleef Duits, wat het gefaalde revanchisme van 1864 belichaamde.',
    ],
    [
      'Welk historiografisch debat omgeeft Denemarkens WWII-bezetting met betrekking tot de vervolging en redding van Joden?',
      [
        'Pragmatisme of medeplichtigheid',
        'Er bestaat universele consensus dat Denemarken onschuldig was',
        'Denemarken vervolgde Joden actief',
        'Geen collaboratie vond plaats',
      ],
      0,
      'Wetenschap debatteert over de bezettingsstrategie. De meeste Joden werden gered, wat pragmatische tegenstand of medeplichtigheid suggereert.',
    ],
    [
      'Hoe hervormde de Kanslergade-coalitie van 1933 het Deense arbeidsrecht, de lonen en de welvaartsverschuiving?',
      [
        'Minimumloon en uitkering',
        'De overeenkomst schafte arbeidersrechten af',
        'Het versterkte landeigenaar-feodalisme',
        'Er was geen overeenkomst van 1933',
      ],
      0,
      'Het Kanslergade-Akkoord van 1933 legde arbeidsstandaarden wettelijk vast. Deze grensoverschrijdende coalitie liep vooruit op het Noordse model.',
    ],
    [
      'Hoe concurreerde de ideologie van "folkestyre" (populair bewind) met monarchale soevereiniteit in constitutionele schikkingen?',
      [
        'Meer stemrecht, minder veto',
        'Folkestyre had geen impact',
        'De monarchie werd absoluter',
        'Folkestyre verwierp democratie',
      ],
      0,
      'Grundtvigaanse en sociaaldemocratische "folkestyre" bevorderde parlementaire democratie ten koste van de monarchie. De Grondwet van 1953 vestigde de suprematie van het parlement.',
    ],
    [
      'Hoe hervormde Denemarkens toetreding tot de EG in 1973 het landbouwbeleid, de regionale identiteit en de welvaartsconsensus?',
      [
        'GLB dwong welvaartsaanpassingen af',
        'Denemarken verwierp Europese integratie',
        'De EEG loste op na Deense toetreding',
        'Landbouw profiteerde zonder aanpassing',
      ],
      0,
      'EG-toetreding blootstelde de Deense landbouw aan CAP maar subsidieerde uitvoer. Welvaartsaanpassingen balanceerden Europese integratie met universalisme.',
    ],
    [
      'Hoe creëerde geïnstitutionaliseerde arbeid-kapitaal-staat-onderhandeling de basis van het Deense corporatisme?',
      [
        'Onderhandelde consensus, weinig stakingen',
        'Geen compromis bestond',
        'Denemarken leed onder constant arbeidsgeweld',
        'Corporatisme werd verworpen',
      ],
      0,
      'Na-oorlogse onderhandelingen tussen arbeid, kapitaal en staat produceerden consensusbeleid en lage stakingspercentages.',
    ],
    [
      'Hoe divergeren Deense debatten over welvaartsuniversalisme tegenover selectiviteit van Beveridge en Bismarckiaanse modellen?',
      [
        'Verwierp de middelentoets',
        'Denemarken nam Beveridge geheel aan',
        'Denemarken kopieerde Bismarck direct',
        'Denemarken had geen welvaartsarchitectuur',
      ],
      0,
      'Het Deense welvaartsbeleid benadrukt universele dekking zonder middelentoets, in tegenstelling tot Britse en continentale modellen.',
    ],
    [
      'Welke historiografische herzieningen sinds de jaren 1990 bestrijden na-oorlogse verhalen over Deense tegenstand tegen de bezetting?',
      [
        'Beperkt gewapend verzet',
        'Na-oorlogse verslagen waren geheel juist',
        'Denemarken voerde constante gewapende oorlog',
        'Geen tegenstand vond plaats',
      ],
      0,
      'Recente wetenschap bestrijdt heldhaftige tegenstandsmythen en benadrukt staatsaccommodatie en beperkte gewapende tegenstand.',
    ],
  ],
  professor: [
    [
      'Hoe betwisten recente historiografische herbeoordelingen van de Unie van Kalmar teleologische "Deense dominantie"-verhalen via prosopografische analyse?',
      [
        'Consensueel trilateraal bestuur',
        'De unie was altijd zuiver Deens-beheerst',
        'Recente historici verwerpen alle primaire bronnen',
        'De Unie van Kalmar bestond nooit werkelijk',
      ],
      0,
      'Revisionistische wetenschap toont aan dat de Unie van Kalmar onderhandelde trilaterale gouvernance en gedeelde adel impliceerde—niet unilateraal bewind.',
    ],
    [
      'Welk historiografisch debat blijft over de Øresundtol als "feodale rente" tegenover echt soevereine maritieme belasting?',
      [
        'Soeverein recht of monopolierente',
        'De tol was altijd vrije doorgang',
        'Geen tol bestond ooit',
        'Economen beamen universeel het was billijk',
      ],
      0,
      'Wetenschappers debatteren of de Øresundtol legitieme belasting of monopolierente-extractie was. De vraag werpt licht op middeleeuwse soevereiniteit.',
    ],
    [
      'Hoe onthullen prosopografische databases van het Rigsråd-lidmaatschap (1380–1660) factieconflicten die het koninklijke gezag beperkten?',
      [
        'Adelsfacties beperkten absolutisme',
        'De adel had geen macht',
        'Alle edelen waren verenigd',
        'Adellijke geslachtsboeken zijn irrelevant',
      ],
      0,
      'Prosopografisch onderzoek onthult competerende adelsfacties en verwantschapsblokken die de monarchie vóór 1660 beperkten.',
    ],
    [
      'Welke revisionistische interpretaties van de Kongelov van 1660 benadrukken contingentie tegenover inherente legitimiteit?',
      [
        'Fiscale crisis, adelscoalities',
        'De Kongelov was onvermijdelijk en populair',
        'Geen contingentiefactoren bestonden',
        'De koning was altijd absolutistisch',
      ],
      0,
      'Revisionistisch werk stelt dat de staatsgreep van 1660 werd aangewakkerd door fiscale crisis en anti-aristocratisch sentiment, eerder dan door onvermijdelijk absolutisme.',
    ],
    [
      'Hoe onthullen kwantitatieve studies van mantalslister (bevolkingsregisters) regionale ongelijkheid binnen het agrarische "verbeteringsnarratief"?',
      [
        'Rijkdom-ongelijkheid',
        'De registers tonen perfecte gelijkheid',
        'Alle boeren werden gelijk rijk',
        'Geen regionale variatie bestond',
      ],
      0,
      'Kwantitatieve studies onthullen blijvende regionale ongelijkheid en landloosheid ondanks het "verbeteringsnarratief".',
    ],
    [
      'Welke historiografische spanningen bestaan tussen het vieren van Grundtvig als progressieve pedagoog tegenover kritiek op etnisch-nationalistische strijd?',
      [
        'Democratisering vs etnicisme',
        'Alle historici prijzen Grundtvig unaniem',
        'Grundtvig had geen nationalistische ideologie',
        'Volksscholen hadden geen impact',
      ],
      0,
      'Wetenschap stelt in vraag of Grundtvigs didactiek democratisering of etnisch nationalisme vertegenwoordigde.',
    ],
    [
      'Hoe compliceren postkoloniale herbeoordelingen van Deense activiteiten in West-Afrika, het Caribisch gebied en Azië "vredige natie"-verhalen?',
      [
        'Slavenhandel en extractie',
        'Denemarken engageerde zich nooit in kolonialisme',
        'Deense koloniën waren geheel weldadig',
        'Koloniale exploitatie is irrelevant',
      ],
      0,
      'Postkoloniaal werk onthult Deense slavenhandel en koloniale extractie, wat het "vredige Denemarken"-verhaal compliceert.',
    ],
    [
      'Welk historiografisch debat stelt het Kanslergade-Akkoord van 1933 als trilateraal corporatisme tegenover crisisgedreven coalitie?',
      [
        'Corporatisme of crisisonderhandeling',
        'De overeenkomst was een democratische revolutie',
        'Geen onderhandeling vond plaats',
        'De overeenkomst had geen politieke betekenis',
      ],
      0,
      'Historici debatteren of het akkoord van 1933 institutionalisering van corporatisme of crisisgedreven coalitievorming weerspiegelt.',
    ],
    [
      'Hoe bestrijden recente verslagen van Denemarkens WWII-bezetting de na-oorlogse "tegenstandsmythologie", terwijl ze ook Holocaust-debatten aangaan?',
      [
        'Genuanceerd verzet, meer accommodatie',
        'Na-oorlogse verslagen waren geheel juist',
        'Denemarken participeerde actief in de Holocaust',
        'Geen historiografische herziening vond plaats',
      ],
      0,
      'Revisionistisch werk bestrijdt na-oorlogse mythen en benadrukt staatsaccommodatie, terwijl Jodenredding als contingent wordt gecontextualiseerd.',
    ],
    [
      'Wat onthullen micro-economische analyses van de coöperatievebeweging over risicospreiding voorbij simplistische "Deens Model"-verhalen?',
      [
        'Transactiekosten via netwerken',
        'Coöperaties hadden geen economische functie',
        'Alle coöperaties waren evenzeer succesvol',
        'Boeren hadden geen agentschap in creatie',
      ],
      0,
      'Micro-economische analyses onthullen hoe coöperaties transactiekosten beperken. Regionale en sectorale variatie is uitgesproken.',
    ],
    [
      'Hoe weerspiegelen de Grundloven van 1849 en de constitutionele herschrijving van 1953 divergente opvattingen van monarchale soevereiniteit?',
      [
        '1849 machtsbalans; 1953 eenkamerig',
        'Beide grondwetten waren identiek',
        'De herziening van 1953 versterkte de monarchie',
        'Grondwettelijke hoven waren uitgevonden in 1953',
      ],
      0,
      '1849 balanceerde monarchie en parlement; 1953 vestigde de suprematie van het parlement via een eenkamerig Folketing.',
    ],
    [
      'Welke historiografische debatten blijven over Noordse welvaart als "klassencompromis" tegenover "sociaaldemocratische hegemonie"?',
      [
        'Compromis of hegemonie, omstreden',
        'Er bestaat universele consensus over welvaartsoorsprong',
        'Geen klassenconflict vormde welvaart',
        'Welvaartsstaten ontstonden spontaan',
      ],
      0,
      'Historici debatteren of Noordse welvaart een onderhandeld compromis of sociaaldemocratische hegemonie weerspiegelt.',
    ],
    [
      'Hoe ondervragen kwantitatieve studies van de "grote egalisering" (jaren 1960–1980) via belastinggegevens zowel gelijkheidsvorderingen als blijvende tegenstellingen?',
      [
        'Inkomenscompressie, blijvende genderkloof',
        'Inkomstenongelijkheid steeg voortdurend',
        'Geslacht- en regionale tegenstellingen verdwenen geheel',
        'Belastinggegevens zijn onbetrouwbare bronnen',
      ],
      0,
      'Kwantitatieve studies onthullen aanzienlijke inkomstencompressie naast blijvende geslacht- en regionale tegenstellingen.',
    ],
    [
      'Welke rol speelt het "Deense exceptionalisme"-raamwerk in de welvaartsstaattheorie, en bevordert het de analyse of belemmert het die?',
      [
        'Verdoezelt gedeelde druk',
        'Denemarken is objectief uniek',
        'Vergelijkende analyse is onmogelijk',
        'Welvaartsstaten zijn onvergelijkbaar',
      ],
      0,
      'Critici betogen dat "exceptionalisme"-raamwerken contingentie obscureren. Relationele analyse kan Noordse uitkomsten beter verklaren.',
    ],
    [
      'Hoe onthult archiefstudie van de onderhandelingen over de EG-toetreding van 1973 spanning tussen agrarische doelen en fiscale soevereiniteit?',
      [
        'Voorrang GLB boven soevereiniteit',
        'Denemarken wilde isolatie',
        'EG-toetreding was geheel vrijwillig en kosteloos',
        'Geen archiefevidentia bestaat',
      ],
      0,
      'Archiefwerk toont dat de Deense toetreding tot de EG van 1973 CAP-toegang en fiscale transfers boven soevereiniteit prioriteerde.',
    ],
  ],
};
